import { render, staticRenderFns } from "./BookDetailEdit.vue?vue&type=template&id=6ca06223&"
import script from "./BookDetailEdit.vue?vue&type=script&lang=js&"
export * from "./BookDetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports